// src/installation.js
//
// RULING 312 (Bob 2026-10-13): the installation's binding, read from src\installation.json - the one file another
// installation of the same core changes. Nothing else in src names the Firebase project, the functions host, the site or
// the platform's name.
import INSTALLATION from './installation.json';

export { INSTALLATION };
export const PLATFORM_NAME = INSTALLATION.platformName;
export const SITE_URL = INSTALLATION.siteUrl;
export const firebaseConfig = {
  projectId: INSTALLATION.projectId,
  appId: INSTALLATION.appId,
  storageBucket: INSTALLATION.storageBucket,
  apiKey: INSTALLATION.apiKey,
  authDomain: INSTALLATION.authDomain,
  messagingSenderId: INSTALLATION.messagingSenderId,
};
// An HTTP function of this installation, by name.
export function functionUrl(name) {
  return 'https://' + INSTALLATION.functionsRegion + '-' + INSTALLATION.projectId + '.cloudfunctions.net/' + name;
}
export const ANALYZE_URL = functionUrl('analyzeClaimRules');